var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ABC89E5B-F5CE-4BDF-974A-E7D3C8A20F50@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "2.-Atoms",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table-Elements",
    transform: "translate(-612.000000, -322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn/24/order/rejected",
    transform: "translate(612.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#7F9BA6",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#B2C3C9",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 24,
    height: 7
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "\\uE876",
    fillOpacity: 0.96,
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "9.75 17.2382812 18.75 8.23828125 17.6953125 7.18359375 9.75 15.1640625 6.5859375 12 5.56640625 13.0546875"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejected);
export default __webpack_public_path__ + "static/media/rejected.434760bb5e943bf3cf2064bf09c2731c.svg";
export { ForwardRef as ReactComponent };